import React from "react";
import HeroSection from "./components/HeroSection";
import SocialProofSection from "./components/SocialProofSection";
import PricingSection from "./components/PricingSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import DemoModal from "./components/DemoModal";
import SuccessModal from "./components/SuccessModal";

const initialState = {
  email: "",
  companyName: "",
  name: "",
  message: "",
};


// // TODO: Replace this placeholder with actual testimonials
// const testimonials = [
//   {
//     "quote": "PLACEHOLDER_QUOTE_1",
//     "author": "PLACEHOLDER_AUTHOR_1", 
//     "title": "PLACEHOLDER_TITLE_1",
//     "avatar": "PLACEHOLDER_AVATAR_URL_1"
//   },
//   {
//     "quote": "PLACEHOLDER_QUOTE_2",
//     "author": "PLACEHOLDER_AUTHOR_2",
//     "title": "PLACEHOLDER_TITLE_2", 
//     "avatar": "PLACEHOLDER_AVATAR_URL_2"
//   },
//   {
//     "quote": "PLACEHOLDER_QUOTE_3",
//     "author": "PLACEHOLDER_AUTHOR_3",
//     "title": "PLACEHOLDER_TITLE_3",
//     "avatar": "PLACEHOLDER_AVATAR_URL_3"
//   }
// ];

const StaticHomePage = () => {
  const [formData, setFormData] = React.useState(initialState);
  const [showModal, setShowModal] = React.useState(false);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [submitError, setSubmitError] = React.useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleInitialSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://website-backend-2efiylvufa-uc.a.run.app/connect",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit form");
      }

      setIsSubmitted(true);
      setShowModal(false);
      setShowSuccess(true);
      setSubmitError(null);
      // Reset form data
      setFormData(initialState);
    } catch (error) {
      console.error("Submission error:", error);
      setSubmitError("Failed to submit form. Please try again later.");
    }
  };

  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <HeroSection 
        formData={formData}
        handleChange={handleChange}
        handleInitialSubmit={handleInitialSubmit}
        isSubmitted={isSubmitted}
      />
      
      <SocialProofSection />
      
      <PricingSection setShowModal={setShowModal} />
      
      <CTASection setShowModal={setShowModal} />
      
      <Footer />

      <DemoModal 
        showModal={showModal}
        setShowModal={setShowModal}
        formData={formData}
        handleChange={handleChange}
        handleModalSubmit={handleModalSubmit}
        submitError={submitError}
      />

      <SuccessModal 
        showSuccess={showSuccess}
        setShowSuccess={setShowSuccess}
      />
    </div>
  );
};

export default StaticHomePage;
